const PreviewPageStyles = `
  html, body { margin: 0; background: #f4f6f8; color: #1b1f24; }
  body { font-family: Georgia, "Times New Roman", serif; }
  .page { max-width: 52rem; margin: 0 auto; padding: 2rem 1.5rem 3rem; background: #fff; min-height: 100vh; box-sizing: border-box; }
  img { max-width: 100%; height: auto; }
  table { border-collapse: collapse; width: 100%; margin: 1rem 0; font-family: Arial, sans-serif; font-size: 0.85rem; }
  td, th { border: 1px solid #d5dde5; padding: 0.35rem 0.5rem; vertical-align: top; }
  th { background: #f3f6f8; }
  pre { white-space: pre-wrap; word-break: break-word; font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace; font-size: 0.85rem; }
`;

export function openRenderedPreviewTab(title: string, innerHtml: string): boolean {
  const tab = window.open("", "_blank");
  if (!tab) {
    return false;
  }

  tab.opener = null;
  const safeTitle = title.replace(/[<>&]/g, "");
  tab.document.open();
  tab.document.write(`<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="utf-8" />
  <title>${safeTitle}</title>
  <style>${PreviewPageStyles}</style>
</head>
<body>
  <div class="page">${innerHtml}</div>
</body>
</html>`);
  tab.document.close();
  return true;
}
